import {useEffect, useState} from "react";
import {AuthUser} from "aws-amplify/auth";
import axios from "axios";
import {settings} from "../config";
import {getTokenService} from "./useTokenService";

export const useUserManager = (user: any) => {
    const [users, setUsers] = useState<AuthUser[]>([]);
    let {token} = getTokenService({user: user})
    useEffect(() => {
        getUsers().then(() => {
        })
    }, []);
    const getUsers = async () => {
        const {data} = await axios({
            url: settings.baseUrl + 'AdminBidList/GetAllUsers',
            method: 'get',
            headers: {"Authorization": "Bearer " + token()}
        });
        setUsers(data)
    }
    return {
        users: users
    }
}